import React from 'react'
import Layout from '../components/Layout'
import Seo from '../components/Seo'

export default () => (
	<Layout>
		<Seo
			title="Contact Us"
			keywords={[`blog`, `gatsby`, `javascript`, `react`]}
		/>
		<div className="inner-wrap-container">
			<div className="inner-wrap visible animate fade-in">
				<div className="single-article">
					{/* OPTIONAL: Featured Image: */}
					<div
						className="featured-image"
						style={{
							backgroundImage: `url(https://source.unsplash.com/random/1024)`,
						}}
					/>
					{/* OPTIONAL: Featured Image: */}

					<div className="post-content m-auto">
						<h1 className="title">Contact</h1>
						<div className="content">
							<form
								action="https://formspree.io/email@domain.tld"
								method="POST"
							>
								<input type="text" placeholder="Name" name="name" />
								<input type="email" placeholder="Email" name="_replyto" />
								<textarea
									name="message"
									placeholder="Message"
									spellcheck="false"
								/>
								<input
									class="btn btn-primary"
									type="submit"
									value="Send Message"
									rows="4"
								/>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
)
